/** Which `stem_one` / `stem_few` / `stem_many` key to use after a Polish cardinal (typical masculine inanimate pattern: jeden X / kilka X-y / pięć X-ów). */
export type PolishCountableForm = "one" | "few" | "many";

/** Picks **`one`** / **`few`** / **`many`** for **count**. Not CLDR: e.g. 21 lands in **`many`** with 20. */
export function polishCountableForm(count: number): PolishCountableForm {
  if (count === 1) return "one";
  const mod10 = count % 10;
  const mod100 = count % 100;
  const isFewTeensExcluded =
    mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20);
  if (isFewTeensExcluded) return "few";
  return "many";
}
